// shared by the mcq answer sheet popup and the score / answer sheet downloads

// question is stored as [{type: text|equation|image, value}], older ones as plain text
export function questionParts(question) {
    if (Array.isArray(question.question)) return question.question;
    try {
        const parts = JSON.parse(question.question);
        if (Array.isArray(parts)) return parts;
    } catch (e) {
        // plain text question
    }
    return [{ type: "text", value: question.question }];
}

// correct | wrong | unanswered
export function questionResult(question, answer) {
    const picked = answer ? answer.choice_id : null;
    if (!picked) return "unanswered";
    const choice = question.choices.find((item) => item.id == picked);
    return choice && Number(choice.is_right_choice) ? "correct" : "wrong";
}

export function answerSummary(questions, answers) {
    const summary = { correct: 0, wrong: 0, unanswered: 0 };
    questions.forEach((question) => summary[questionResult(question, answers[question.id])]++);
    return summary;
}

export function formatMark(mark) {
    const value = Number(mark || 0);
    return Number.isInteger(value) ? value : value.toFixed(2).replace(/0+$/, "");
}
